export const startupTranslation = {
  new_case_header: 8255,
  new_case_description: 8256,
  new_case_register: 8257,
  open_case_header: 8251,
  open_case_case_no: 8252,
  open_case_case_password: 8253,
  open_case: 8254
};
